"use client";

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const properties = [{
  id: 0,
  era: "Recent Project · 2024",
  price: "Industrial",
  name: "Featured Project",
  address: "Current Work",
  specs: "",
  badge: "NEW",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_0517.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_0517.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_0517.jpg-wvc-sizes",
  notes: ""
}, {
  id: 0.5,
  era: "Recent Project · 2024",
  price: "Industrial",
  name: "Featured Project",
  address: "Current Work",
  specs: "",
  badge: "NEW",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_1017.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_1017.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/IMG_1017.jpg-wvc-sizes",
  notes: ""
}, {
  id: 1,
  era: "Mechanical · 2023",
  price: "Industrial",
  name: "Machinery Rigging",
  address: "Detroit Manufacturing Hub",
  specs: "",
  badge: "COMPLETED",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio2.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio2.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio2.jpg-wvc-sizes",
  notes: ""
}, {
  id: 2,
  era: "Fabrication · 2022",
  price: "Structural",
  name: "Machinery Guarding Fabrication and Installation",
  address: "Logistics Center, Ohio",
  specs: "WELDING / DESIGN / 12,000 SQFT / 8 WEEKS",
  badge: "ONGOING",
  badgeType: "open",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio10.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio10.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio10.jpg-wvc-sizes",
  notes: ""
}, {
  id: 3,
  era: "Piping · 2023",
  price: "Process",
  name: "Hoist Installation",
  address: "Gulf Coast Facility",
  specs: "STAINLESS / HIGH-PRESSURE / 4,000 LF / 16 WEEKS",
  badge: "",
  badgeType: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio8.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio8.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio8.jpg-wvc-sizes",
  notes: ""
}, {
  id: 4,
  era: "Rigging · 2021",
  price: "Heavy Lift",
  name: "Robotic Packaging Line Installation",
  address: "Regional Power Station",
  specs: "CRANE OPS / LOGISTICS / 800 TONS / 4 WEEKS",
  badge: "COMPLETED",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio20.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio20.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio20.jpg-wvc-sizes",
  notes: ""
}, {
  id: 5,
  era: "Millwright · 2022",
  price: "Precision",
  name: "Pump Installation",
  address: "Northern Industrial Park",
  specs: "ALIGNMENT / REPAIR / 24/7 OPS / 6 WEEKS",
  badge: "ONGOING",
  badgeType: "open",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio26.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio26.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio26.jpg-wvc-sizes",
  notes: ""
}, {
  id: 6,
  era: "General · 2023",
  price: "Turnkey",
  name: "Machinery Rigging",
  address: "Central Valley Facility",
  specs: "",
  badge: "",
  badgeType: "",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/Pic3r.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/Pic3r.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/Pic3r.jpg-wvc-sizes",
  notes: ""
}, {
  id: 7,
  era: "Fabrication · 2024",
  price: "Structural",
  name: "Machinery Rigging",
  address: "Industrial Park East",
  specs: "",
  badge: "NEW",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/Pic1r.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/steel_mezzanine_fabrication.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/steel_mezzanine_fabrication.png-wvc-sizes",
  notes: "Design and fabrication of a multi-level industrial mezzanine to optimize warehouse storage capacity and workflow efficiency."
}, {
  id: 8,
  era: "Rigging · 2023",
  price: "Heavy Lift",
  name: "Platform Fabrication",
  address: "Power Grid Substation",
  specs: "",
  badge: "COMPLETED",
  badgeType: "new",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio4.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio4.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio4.jpg-wvc-sizes",
  notes: ""
}, {
  id: 9,
  era: "Millwright · 2024",
  price: "Mechanical",
  name: "LED Sign Installation",
  address: "Regional Distribution Center",
  specs: "MAINTENANCE / INSTALL / 2,500 LF / 5 WEEKS",
  badge: "ONGOING",
  badgeType: "open",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio13.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio13.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco-portfolio13.jpg-wvc-sizes",
  notes: ""
}];
export default function Fieldworkportfolio() {
  return <section data-section-id="3335" id="fieldworkportfolio" className="dark bg-[#3954a5] text-foreground font-default">
      <div className="px-6 md:px-12 lg:px-16 py-20 md:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-7 md:col-start-2">
            <p className="font-default text-xs uppercase tracking-[0.2em] text-secondary mb-6 md:mb-8">Project snapshots</p>
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-foreground font-bold">
              Industrial <em className="italic font-light text-secondary">excellence</em>
              <br />
              in action.
            </h1>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 pt-8 pb-16 md:pt-12 md:pb-24">
        <div className="relative max-w-6xl mx-auto">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {properties.map((property, index) => <CarouselItem key={property.id} data-index={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="relative overflow-hidden aspect-[4/5] bg-muted rounded-lg shadow-md group">
                    <img src={property.image} data-wvc-srcset={property.srcset} data-wvc-sizes={property.sizes} alt={property.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="left-[-3rem] border-white/20 bg-white/10 text-white hover:bg-secondary hover:text-white" />
              <CarouselNext className="right-[-3rem] border-white/20 bg-white/10 text-white hover:bg-secondary hover:text-white" />
            </div>
          </Carousel>
        </div>

        <div className="mt-20 md:mt-24 flex justify-center">
          {}
        </div>
      </div>
    </section>;
}